import './SiderContent.scss';
import React, { useState } from 'react';
import { Button, Layout } from 'antd';
import { Link } from 'react-router-dom';

import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import MainMenu from '../menu/Main';

type Props = {
  currentUser?: any;
};

const { Sider } = Layout;

const MainSiderContent: React.FC<Props> = ({ currentUser }) => {
  const [collapsed, setCollapsed] = useState(false);

  const onTriggerClick = () => {
    setCollapsed(!collapsed);
  };

  return (
    <>
      <Sider
        breakpoint="lg"
        theme="light"
        collapsible
        collapsedWidth={0}
        trigger={null}
        collapsed={collapsed}
        onBreakpoint={(broken) => {
          if (broken) setCollapsed(true);
          else setCollapsed(false);
        }}
        className="sider side-menu-component"
      >
        <div className="logo">
          <Link to="/">
            <img src="/logo.png" alt="logo" />
          </Link>
        </div>
        <MainMenu currentUser={currentUser} />
      </Sider>
      <div className={`mobile-toggle-menu ${collapsed ? 'hide' : 'open'}`}>
        <Button className="trigger" onClick={onTriggerClick}>
          {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
        </Button>
      </div>
    </>
  );
};

export default MainSiderContent;
